import { SignIn } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sign-in")({
  component: SignInPage,
});

function SignInPage() {
  return (
    <div className="grid min-h-screen place-items-center bg-background p-6">
      {/* Appearance comes from ClerkProvider, so this box is themed with the
          rest of the app in both light and dark. */}
      {/* Hash routing keeps Clerk's multi-step flow inside this one route
          rather than needing a splat. The footer is hidden because access here
          comes from a staff_users row, not from signing yourself up. */}
      <SignIn routing="hash" appearance={{ elements: { footer: "hidden" } }} />
    </div>
  );
}
